import { useAssessmentStore } from '../store/assessmentStore'
import { AssessmentStep } from '../types'

const steps: { key: AssessmentStep; label: string }[] = [
  { key: 'login', label: 'Login' },
  { key: 'face-enrollment', label: 'Identity' },
  { key: 'assessment', label: 'Assessment' },
  { key: 'results', label: 'Results' },
]

export default function ProgressIndicator() {
  const { currentStep } = useAssessmentStore()

  const currentIndex = steps.findIndex((s) => s.key === currentStep)

  return (
    <div className="flex items-center gap-1 sm:gap-2 overflow-hidden">
      {steps.map((step, index) => {
        const isCompleted = index < currentIndex
        const isCurrent = index === currentIndex
        const isPending = index > currentIndex

        return (
          <div key={step.key} className="flex items-center shrink-0">
            {/* Step indicator */}
            <div className="flex flex-col items-center">
              <div
                className={`
                  w-6 h-6 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs sm:text-sm font-medium
                  transition-all duration-300
                  ${isCompleted ? 'bg-green-500 text-white' : ''}
                  ${isCurrent ? 'bg-primary-500 text-white ring-2 ring-primary-300' : ''}
                  ${isPending ? 'bg-gray-700 text-gray-400' : ''}
                `}
              >
                {isCompleted ? (
                  <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={`
                  text-xs mt-1 hidden md:block whitespace-nowrap
                  ${isCurrent ? 'text-primary-400' : 'text-gray-500'}
                `}
              >
                {step.label}
              </span>
            </div>

            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className={`
                  w-4 sm:w-8 h-0.5 mx-0.5 sm:mx-1
                  ${index < currentIndex ? 'bg-green-500' : 'bg-gray-700'}
                `}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
